import { MarkerWrapper } from '../CustomPoint/CustomPoint';
import { Point, Route, TSFixMe } from '../../../types';

interface IgetPoints {
  points: Point[];
  route?: Route;
  selectedPoint?: Point;
  map: google.maps.Map;
  onMarkerClick?: (event: TSFixMe, point: Point) => void;
}

export const getPoints = ({ points, route, selectedPoint, map, onMarkerClick }: IgetPoints) => {
  const array: JSX.Element[] = [];

  const last = points.length - 1;

  points.forEach((point, index) => {
    const key = route?.id ? `-` : point.id;
    const isSelected = point.id === selectedPoint?.id;
    const label = route ? index + 1 : undefined;
    const emphasized = !!route && (index === 0 || index === last);

    array.push(
      <MarkerWrapper
        key={key}
        isSelected={isSelected}
        point={point}
        label={label}
        emphasized={emphasized}
        onClick={onMarkerClick}
        map={map}
      />
    );
  });

  return array;
};
